import React, {useState} from 'react';
import { ContainerCoverVideo, Container, TitleSub, HeaderSdg, ContainerChart, Subtitle } from '../../components/AppComponents';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more'; 
import highchartsGroupedCategories from 'highcharts-grouped-categories';

import { figure67 } from '../../graphs/fr/figure67';
import { figure70 } from '../../graphs/fr/figure70';
import { figure71 } from '../../graphs/fr/figure71';
import { figure74 } from '../../graphs/fr/figure74';
import { figure75 } from '../../graphs/fr/figure75';
import { figure76 } from '../../graphs/fr/figure76';
import { figure81 } from '../../graphs/fr/figure81';
import Modal from "../../components/Modal";

// import { figure55 } from '../graphs/fr/figure55';
// eslint-disable-next-line
highchartsMore(Highcharts);
highchartsGroupedCategories(Highcharts);

const Sdg15 = () => {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(false);

    const handleClickOpen = (value) => {
        setOpen(true);
        setText(value);
    };

    const handleClose = (value) => {
        setOpen(false);
        setText(value);
    };
    return (
      
        <React.Fragment>
            <Modal
                text={text}
                open={open}
                onClose={handleClose}
            />
            <ContainerCoverVideo 
                id="15"
                poster={require('../../images/poster-sdg-15.png').default}
                video={require('../../images/video-sdg-15.mp4').default}
                sdgImage={require('../../images/EN_15.svg').default}
                sdg="OBJECTIF DE DÉVELOPPEMENT DURABLE 15"
                title="Vie terrestre"
                subtitle="Préserver et restaurer les écosystèmes terrestres, en veillant à les exploiter de façon durable, gérer durablement les forêts, lutter contre la désertification, enrayer et inverser le processus de dégradation des sols et mettre fin à l’appauvrissement de la biodiversité."
                summaryTable={require('../../images/Goal_15.zip').default}
                indicators={['15.1.1', '15.2.1', '15.3.1', '15.4.2', '15.6.1']}  
                indicatorsTitle="INDICATEURS"
                summaryTableTitle= "TABLEAUX RÉCAPITULATIFS"
            />

            <Container>
                <TitleSub title="Vue d’ensemble" />
<p>Le monde est confronté à une triple crise d’ampleur planétaire, caractérisée par des changements climatiques, la pollution et une perte de biodiversité. Les tendances en matière de recul de la forêt, de dégradation des terres et d’extinction des espèces s’aggravent, et constituent une menace grave pour la santé de la planète et de ses habitants. À l’échelle mondiale, la superficie forestière totale a reculé de 100 millions d’hectares depuis 2000, même si le taux de perte semble s’être ralenti ces dernières années. Le monde a par ailleurs perdu au moins 100 millions d’hectares de terres saines et productives par an entre 2015 et 2019. Si le couvert végétal des zones montagneuses est resté relativement stable, à environ 78 pour cent, entre 2000 et 2018, les données mondiales disponibles indiquent que la part de terres montagneuses dégradées s’élève à 1,6 pour cent des superficies montagneuses totales de la planète pour la même période. Des signes encourageants montrent que l’adoption de pratiques durables de gestion forestière s’est généralisée au cours des dix dernières années. Un nombre croissant de pays prennent par ailleurs des mesures pour faciliter les échanges de matériel génétique végétal pour promouvoir l’accès et le partage des bénéfices.</p>
<div id="section15.1.1">
                    <HeaderSdg 
                        title="INDICATEUR 15.1.1 DES ODD"
                        subtitle="Surface des zones forestières, en proportion de la surface terrestre"
                        badges={[
                            {color: '#FFFF00', text: 'Évaluation de la situation à l’échelle mondiale: au niveau de la médiane des valeurs nationales'},
                            { color: '#ff6261', text: 'Évaluation des tendances à l’échelle mondiale: détérioration.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Cible 15.1',
                            text: 'D’ici à 2020, garantir la préservation, la restauration et l’exploitation durable des écosystèmes terrestres et des écosystèmes d’eau douce et des services connexes, en particulier des forêts, des zones humides, des montagnes et des zones arides, conformément aux obligations découlant des accords internationaux.'
                        }}
                    />
                </div>

<p><b>En 2020, les forêts couvraient 31,2 pour cent de la surface terrestre totale, soit une baisse de 100 millions d’hectares au cours des vingt dernières années.</b></p>
<p>La part de la surface terrestre totale couverte par des forêts baisse de manière progressive, passant de 31,9 pour cent en 2000 (4,2 milliards d’hectares) à 31,5 pour cent en 2010 puis à 31,2 pour cent (4,1 milliards d’hectares) en 2020 (figure 67). Depuis la mise en œuvre du Programme 2030 en 2015, le couvert forestier a connu un déclin global de 0,2 pour cent, soit près de 25 millions d’hectares. Cela représente environ un quart des pertes nettes de superficie forestière, qui s’élèvent à près de 100 millions d’hectares au cours des vingt dernières années.</p>
<p>Cette tendance mondiale est le fruit de dynamiques régionales contraires. L’Europe, l’Amérique du Nord et la plupart des régions d’Asie affichent une hausse générale de la superficie forestière pour la période 2000-2020, grâce à des actions de boisement et de restauration des paysages, ainsi qu’à l’expansion naturelle des forêts (figure 67). Plus particulièrement, la superficie forestière a augmenté de 3,64 pour cent en Asie de l’Est, mais a baissé de 3,65 pour cent pendant la même période en Asie du Sud-Est. L’expansion de la superficie forestière a toutefois ralenti entre 2010 et 2020 par rapport à la décennie précédente.</p>
<p>Inversement, des pertes importantes de superficie forestière ont eu lieu ces 20 dernières années en Amérique latine et en Afrique subsaharienne. Les PMA sont particulièrement touchés par ces pertes. Si, en Amérique latine, la déforestation est causée par la conversion des forêts en pâturages, en Afrique subsaharienne, le principal moteur de ce phénomène est l’expansion des terres cultivées. L’expansion agricole est d’ailleurs directement responsable de près de 90 pour cent de la déforestation à l’échelle mondiale. Il s’agit du facteur direct de déforestation le plus important (49,6 pour cent), suivi de la création de pâturages (38,5 pour cent). L’huile de palme était responsable à elle seule de 7 pour cent de la déforestation mondiale entre 2000 et 2018.</p>
<p>Les forêts jouent un rôle important pour la subsistance et le bien-être des populations rurales et urbaines. Elles contribuent de manière notable à la régulation du cycle de l’eau, à l’atténuation des changements climatiques et au maintien d’une grande partie de la biodiversité terrestre. La perte de forêts perturbe les dynamiques écosystémiques tout en nuisant au climat, aux interactions entre l’humanité et la vie sauvage, aux liens entre les activités d’utilisation des terres et à la fourniture de services écosystémiques.</p>
<p>Si les effets à court terme et à long terme de la crise du covid-19 sur la superficie forestière n’ont pas encore été mesurés, la pandémie a eu des effets directs sur le couvert forestier et la sylviculture en raison de changements dans les flux de population entre les villes et les campagnes et de la hausse de la demande de certains produits forestiers. De nombreuses zones rurales, en particulier dans les tropiques, ont subi des pressions supplémentaires exercées par la déforestation, l’exploitation forestière illégale et le braconnage.</p>
<p>Il est essentiel de maintenir la dynamique visant à stopper la déforestation et la dégradation des forêts, mais aussi de restaurer les écosystèmes endommagés, afin d’améliorer la résilience climatique des écosystèmes, d’éviter les pertes de biodiversité et d’améliorer les moyens de subsistance ruraux, en particulier dans les pays tropicaux et les PMA.</p>
	    </Container>
<ContainerChart 
                title="Figure 67. Surface des zones forestières, en proportion de la surface terrestre, pourcentage (2000, 2010, 2015 et 2020)"
                legend={[
                    {title: '2000', color: '#70ad47'},
                    {title: '2010', color: '#a9d18e'},
                    {title: '2015', color: '#e2f0d9'},
                    {title: '2020', color: '#385723'},
                ]}
                note={<span>Source: FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig67" download>https://doi.org/10.4060/CC7088EN-fig67</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure67}
                />
                
            </ContainerChart>
{/* Interactive Map  */}
            <ContainerChart
                title="Figure 68. Évolution de la surface des zones forestières, en proportion de la surface terrestre (2015-2020)"
                legend={[
                    {title: 'Amélioration', color: '#00a700'},
                    {title: 'Légère amélioration ou absence d’amélioration', color: '#2acb2a'},
		    {title: 'Légère détérioration', color: '#ffa500'},
		    {title: 'Détérioration', color: '#ff0000'},
		    {title: 'Données insuffisantes', color: '#808080'},
                ]}
                source={<span><b>Source:</b> FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a> (modifié pour s’aligner sur la Section de l’information géospatiale des Nations Unies, 2023).<br/></span>}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l’Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre le Soudan et le Soudan du Sud n’a pas encore été défini.<br/>Le statut définitif de la zone d’Abyei n’est pas encore déterminé. La souveraineté sur les îles Falkland (Malvinas) fait l’objet d’un différend entre le Gouvernement de l’Argentine et le Gouvernement du Royaume-Uni de Grande-Bretagne et d’Irlande du Nord.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map68' src="fig68.html" width='100%'  height='500px'/>

            </ContainerChart>
            <Container>
                <div id="section15.2.1">
                    <HeaderSdg 
                        title="INDICATEUR 15.2.1 DES ODD"
                        subtitle="Progrès vers la gestion durable des forêts"
                        badges={[
                            {color: '#cecece', text: 'Évaluation de la situation à l’échelle mondiale: non effectuée pour des raisons méthodologiques.'},
                            {color: '#cecece', text: 'Évaluation des tendances à l’échelle mondiale: non effectuée pour des raisons méthodologiques.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Cible 15.2',
                            text: 'D’ici à 2020, promouvoir la gestion durable de tous les types de forêt, mettre un terme à la déforestation, restaurer les forêts dégradées et accroître nettement le boisement et le reboisement au niveau mondial.'
                        }}
                    />
                </div>

<p><b>Le monde enregistre des avancées vers la gestion durable des forêts, mais le taux de recul de la forêt demeure élevé.</b></p>
<p>Si, à l’échelle mondiale, la gestion durable des forêts connaît des avancées depuis 10 ans, ces progrès sont variables d’une région à l’autre. De plus, les forêts continuent de reculer, principalement à cause du développement de l’agriculture à des fins de production végétale et animale.</p>
<p>En 2022, 444 millions d’hectares de forêts étaient régis par un programme de certification (figure 70). Les superficies forestières certifiées ont connu une hausse de 29 pour cent, équivalant à environ 100 millions d’hectares de terres supplémentaires depuis 2010. Cette tendance positive se manifeste surtout en Europe et en Amérique du Nord, où 65 millions d’hectares ont été certifiés entre 2010 et 2022. Les dernières données en date montrent toutefois que la superficie forestière certifiée a baissé de 19 millions d’hectares (4 pour cent) entre 2021 et 2022.</p>
<p>La part de superficie forestière située en zone protégée a augmenté à l’échelle mondiale, passant de 17 pour cent en 2010 à 18 pour cent en 2020. La sous-région présentant la plus forte proportion de forêts situées en zones protégées en 2020 était l’Asie centrale (59 pour cent). Cette même région a enregistré la plus forte hausse relative entre 2010 et 2020 (12 pour cent). L’Europe et l’Amérique du Nord affichent la plus faible part de forêts situées en zones protégées, avec seulement 6 pour cent.</p>
<p>La superficie forestière régie par un plan de gestion a augmenté entre 2010 et 2020. La plupart des forêts en Europe et en Asie sont régies par un plan de gestion, et ce nombre a connu une hausse particulièrement importante depuis 2010 en Asie centrale et en Asie de l’Est. La part de forêts régies par des plans de gestion demeure inférieure à un tiers, mais augmente lentement, en Amérique latine et dans les Caraïbes, en Océanie et en Afrique subsaharienne.</p>
<p>La quantité de biomasse aérienne dans les forêts a légèrement augmenté grâce à une hausse notable en Asie de l’Est, en Europe et en Asie de l’Ouest.</p>
<p>Le taux d’évolution annuelle des forêts demeure relativement stable à l’échelle mondiale (environ -0,1 pour cent), ce qui indique que le recul de la forêt se poursuit, mais à un rythme plus modéré. Une expansion de la forêt a été observée en Asie, en Europe et en Amérique du Nord entre 2010 et 2020, tandis que d’importantes pertes ont été enregistrées en Afrique, en Asie du Sud-Est et en Amérique latine et dans les Caraïbes. Ces pertes sont principalement dues à l’expansion de l’agriculture. La déforestation et la dégradation des forêts demeurent d’importants problèmes, en particulier dans les pays tropicaux, les PMA, les pays en développement sans littoral et les PEID, ce qui témoigne de la nécessité d’une action plus poussée pour réduire la déforestation et mettre en œuvre des pratiques de gestion durable des terres et des forêts.</p>
<p>Si les effets à court terme et à long terme de la pandémie de covid-19 sur les forêts sont encore difficiles à mesurer, celle-ci a probablement produit des effets sur les forêts et la sylviculture en raison de changements dans les flux de population entre les villes et les campagnes et de la hausse de la demande de certains produits forestiers.</p>
<p>Les forêts sont les plus importants réservoirs de carbone et de biodiversité de la Terre. Elles sont une source vitale de nourriture, de biens et de services, et jouent un rôle central dans la subsistance des populations les plus pauvres et des communautés rurales. Les efforts mondiaux et régionaux visant à maintenir les écosystèmes forestiers et leurs fonctions sociales, économiques et environnementales doivent être soutenus et mettre l’accent sur les pays tropicaux et en développement.</p>
	    </Container>
            <div className="chart-container">
                <div className="chart-title"><h2>Figure 69. Progrès vers la gestion durable des forêts</h2></div>
                <table className="table desktop-table colored-table">
                    <thead className="subcategory_thead enter" >
                    <tr>
                        <th className="border-0"> </th>
                        <th className="pb-0 w-custom">
                            <div><span><small>Progrès entre les décennies 2000-2010 et 2010-2020</small></span></div></th>
                        <th className="" colSpan="3">
                            <div><span><small>Progrès entre 2010<br/> et 2020</small></span></div></th>
                        <th className="">
                            <div><span><small>Progrès entre 2010<br/> et 2022</small></span></div></th>
                        <th className="">
                            <div><span><small>Progrès entre 2015<br/> et 2022</small></span></div></th>
                        <th className="">
                            <div><span><small>Progrès entre 2021<br/> et 2022</small></span></div></th>
                    </tr>
                    </thead>
                    <thead className="subcategory_thead table-prevalence-title enter">
                    <tr>
                        <th>Région des ODD</th>
                        <th className="rotate">
                            <div><span>Taux de changement annuel de<br/> la superficie forestière*</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Stock de biomasse aérienne dans<br/> la forêt (tonnes/hectare)</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Pourcentage de superficie forestière<br/> se trouvant à l’intérieur d’aires<br/> protégées juridiquement const</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Pourcentage de superficie forestière<br/> soumise à un plan de gestion<br/> forestière à long terme</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Superficie forestière certifiée<br/> (2021-2022)</span></div></th>
                        <th className="rotate pb-0">
                            <div><span>Superficie forestière certifiée<br/> (2015-2022)</span></div></th>
                        <th className="rotate">
                            <div><span>Superficie forestière certifiée<br/> (2021-2022)</span></div></th>
                    </tr>
                    </thead>
                    <thead className="othcategory_thead enter">
                    <tr>
                        <th scope="row" className="teal">Monde</th>
                        <td>
                            <span className="circle-y"></span>
                        </td>
                        <td>
                            <span className="circle-g"></span>

                        </td>
                        <td>
                            <span className="circle-r"></span>

                        </td>
                        <td>
                            <span className="circle-g"></span>

                        </td>
                        <td>
                            <span className="circle-g"></span>

                        </td>
                        <td>
                            <span className="circle-g"></span>

                        </td>
                        <td>
                            <span className="circle-r"></span>

                        </td>
                    </tr>
                    </thead>
                    <tbody className="enter">
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Asie centrale et Asie du Sud</th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">Asie centrale</li></ul></th>
                        <td ><span className="circle-g"></span></td>
                        <td ><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">Asie du Sud</li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Asie de l’Est et Asie du Sud-Est</th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">Asie de l’Est</li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">Asie du Sud-Est</li></ul></th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Asie de l’Ouest et Afrique du Nord</th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">Afrique du Nord</li></ul></th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td scope="row" className="grey"> </td>
                        <td scope="row" className="grey"> </td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">Asie de l’Ouest</li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td scope="row" className="grey"> </td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Afrique subsaharienne</th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Amérique du Nord et Europe</th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">Europe</li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal"><ul className="mb-0"><li className="list-unstyled font-weight-normal">Amérique du Nord</li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Amérique latine et Caraïbes</th>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="font-weight-normal grey">Océanie</th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th><ul className="mb-0"><li className="list-unstyled font-weight-normal">Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)</li></ul></th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                    </tr>
                    <tr>
                        <th><ul className="mb-0"><li className="list-unstyled font-weight-normal">Australie et Nouvelle-Zélande</li></ul></th>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="teal">Pays en développement sans littoral</th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="teal">Pays les moins avancés (PMA)</th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                    </tr>
                    <tr>
                        <th scope="row" className="teal">Petits pays insulaires en développement (PEID)</th>
                        <td><span className="circle-r"></span></td>
                        <td><span className="circle-y"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-g"></span></td>
                        <td><span className="circle-r"></span></td>
                    </tr>
                    </tbody>
                </table>
                <table className="table mobile-table">
                    <tbody>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Monde</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asie centrale et Asie du Sud</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asie centrale</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asie du Sud</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asie de l’Est et Asie du Sud-Est</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asie de l’Est</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asie du Sud-Est</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asie de l’Ouest et Afrique du Nord</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Afrique du Nord</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Asie de l’Ouest</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Afrique subsaharienne</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Amérique du Nord et Europe</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Europe</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Amérique du Nord</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Amérique latine et Caraïbes</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Océanie</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Australie et Nouvelle-Zélande</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Pays en développement sans littoral</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Pays les moins avancés (PMA)</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td colSpan="2" className="country text-center font-weight-bold">Petits pays insulaires en développement (PEID)</td>
                    </tr>
                    <tr>
                        <td className="data border-left-yellow">Taux de changement annuel de la superficie forestière*</td>
                        <td className="data red"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Stock de biomasse aérienne dans la forêt (tonnes/hectare)</td>
                        <td className="data yellow"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière se trouvant à l’intérieur d’aires protégées juridiquement constituées</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Pourcentage de superficie forestière soumise à un plan de gestion forestière à long terme</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2015-2022)</td>
                        <td className="data green"></td>
                    </tr>
                    <tr>
                        <td className="data border-left-green">Superficie forestière certifiée (2021-2022)</td>
                        <td className="data red"></td>
                    </tr>
                    </tbody>
                </table>
                <ul className="list-unstyled list-inline text-center legend legend-table mt-4 half-width-entries">
                    <li className="list-inline-item"><span className="point position-static"></span>Variation positive</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Variation faible ou nulle</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Variation négative</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Pas de forêt certifiée</li>
                </ul>
                <p className="note text-center">Note: * Le taux annuel de changement de la superficie forestière est calculé à l’aide de la formule de l’intérêt composé.<br/>Source: FAO. 2023. Indicateurs. In: <i>Objectifs de développement durable</i>. Rome. Consulté le 8 juin 2023. <a href="https://www.fao.org/sustainable-development-goals-data-portal/data/fr">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a></p>
            </div>
<ContainerChart 
                title="Figure 70. Superficie forestière certifiée (1 000 hectares)"
                legend={[
                    {title: '2010', color: '#e2f0d9'},
                    {title: '2015', color: '#a9d18e'},
                    {title: '2022', color: '#70ad47'},
                ]}
                note={<span><b>Source:</b> FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig70" download>https://doi.org/10.4060/CC7088EN-fig70</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure70}
                />
                
            </ContainerChart>


<Container>
		                <div id="section15.3.1">
                    <HeaderSdg 
                        title="INDICATEUR 15.3.1 DES ODD"
                        subtitle={["Surface des terres dégradées, en proportion de la surface terrestre", <sup>8</sup>]}
                        badges={[
                            {color: '#ffff05', text: 'Évaluation de la situation à l’échelle mondiale : cible en voie d’être atteinte.'},
                            { color: '#ff6261', text: 'Évaluation des tendances à l’échelle mondiale: détérioration.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Cible 15.3',
                            text: 'D’ici à 2030, lutter contre la désertification, restaurer les terres et sols dégradés, notamment les terres touchées par la désertification, la sécheresse et les inondations, et s’efforcer de parvenir à un monde sans dégradation des terres.'
                        }}
                    />
                </div>

<p><b>La tendance négative en matière de dégradation des terres se poursuit et a des répercussions sur la vie de 1,3 milliard de personnes.</b></p>
<p>Entre 2015 et 2019, le monde a perdu au moins 100 millions d’hectares de terres saines et productives par an. Cela équivaut à deux fois le Groenland sur une période de quatre années. Ces tendances produisent des répercussions sur la vie de 1,3 milliard de personnes, qui, selon les estimations, sont directement exposées à la dégradation des terres. En Asie de l’Est, en Amérique latine et dans les Caraïbes et en Asie centrale, au moins 20 pour cent de la surface terrestre a été dégradée entre 2000 et 2019, et ce taux atteint plus de 10 pour cent dans la plupart des autres régions. Les tendances depuis 2015 montrent que les terres en Afrique subsaharienne, en Asie de l’Ouest, en Amérique latine et dans les Caraïbes et en Asie du Sud se dégradent considérablement plus vite que la moyenne mondiale, avec des hausses de l’ordre de 6 à 8 pour cent. Ces estimations prudentes se fondent sur seulement trois sous-indicateurs, à savoir la modification de la couverture des sols, la productivité des terres et le carbone organique dans le sol.</p>
<p>Les activités humaines comme l’expansion urbaine, la déforestation et la conversion des prairies, intensifiées par les changements climatiques, sont les facteurs directs de la dégradation des terres identifiés par les pays. Les prairies ont subi certaines des plus grosses pertes enregistrées en matière de productivité des terres, suivies par les terres cultivées et les zones arborées. Les pays déclarants ont indiqué qu’il convient de s’attaquer aux facteurs indirects, tels que les tendances démographiques et économiques, les défis institutionnels et en matière de gouvernance, et le manque d’investissements et d’accès aux technologies, pour garantir une réponse efficace à la dégradation des terres.</p>
<p>À mi-parcours de la mise en œuvre des ODD, si ces tendances alarmantes en matière de dégradation des terres se poursuivent, il sera nécessaire de restaurer 1,5 milliard d’hectares à l’horizon 2030 pour garantir un monde sans dégradation des terres. Toutefois, si l’on parvient à éviter les nouvelles dégradations des terres et à accélérer la mise en œuvre des engagements existants pour restaurer un milliard d’hectares, l’objectif d’un monde sans dégradation des terres sera non seulement atteint, mais dépassé d’ici 2030. Cela supposera plus d’investissements dans la conservation, la gestion durable et la restauration des terres, par le biais d’une planification intégrée de l’utilisation des terres et de garanties environnementales et sociales solides.</p>
<p>La restauration des terres englobe une large gamme de pratiques durables de gestion des terres et de l’eau qui peuvent être appliquées pour: i) conserver ou «réensauvager» les zones naturelles; ii) améliorer la production alimentaire respectueuse de la nature dans les paysages ruraux; et iii) «verdir» les zones urbaines, les infrastructures et les chaînes d’approvisionnement. Le programme de restauration des terres favorise une stratégie à bénéfices multiples qui inverse la dégradation passée des terres et la perte de biodiversité, tout en améliorant la sécurité alimentaire et hydrique et les moyens de subsistance et en assurant l’adaptation aux changements climatiques et en en atténuant les effets.</p>
<p>La restauration des terres est une responsabilité partagée – tout le monde a un rôle à jouer parce que tout le monde est concerné par la santé de la terre, aujourd’hui et pour les années à venir. Les gouvernements, les entreprises et les communautés peuvent restaurer les terres ensemble en recherchant la convergence et la complémentarité. Les priorités environnementales et de développement peuvent être gérées de manière responsable pour créer une mosaïque plus saine d’utilisations des terres sans compromettre les besoins et les aspirations des générations actuelles et futures.</p>
</Container>
<ContainerChart 
                title="Figure 71. Proportion de terres dégradées, pourcentage (2015 et 2019)"
                legend={[
                    {title: '2015', color: '#a9d18e'},
                    {title: '2019', color: '#e2f0d9'},
                ]}
                note={<span>Notes: 1) À l’exclusion des Maldives; 2) À l’exclusion des États-Unis d’Amérique; 3) À l’exclusion du Bélarus, du Danemark, de la Fédération de Russie, du Luxembourg, de Malte, de Monaco, de la Norvège et de la Suisse; 4) À l’exclusion de l’Angola et des Comores; 5) À l’exclusion du Brunéi Darussalam et de Singapour; 6) À l’exclusion de la Barbade et de la Grenade; et 7) À l’exclusion du Japon et de la République de Corée.<br/><b>Source:</b> FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig71" download>https://doi.org/10.4060/CC7088EN-fig71</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure71}
                />
                
            </ContainerChart>

{/* Interactive Map  */}
            <ContainerChart
                title="Figure 72. État actuel de la superficie des terres dégradées (2019)"
                legend={[
                    {title: 'Cible déjà atteinte', color: '#00a700'},
                    {title: 'Cible sur le point d’être atteinte', color: '#2acb2a'},
		    {title: 'Cible en voie d’être atteinte', color: '#ffff05'},
		    {title: 'Cible loin d’être atteinte', color: '#ffa500'},
		    {title: 'Cible très loin d’être atteinte', color: '#ff0000'},
		    {title: 'Données insuffisantes', color: '#808080'},
                ]}
                source={<span>Source: FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. Consulté le 8 juin 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a> (modifié pour s’aligner sur la Section de l’information géospatiale des Nations Unies, 2023).<br/></span>}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l’Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre le Soudan et le Soudan du Sud n’a pas encore été défini.<br/>Le statut définitif de la zone d’Abyei n’est pas encore déterminé. La souveraineté sur les îles Falkland (Malvinas) fait l’objet d’un différend entre le Gouvernement de l’Argentine et le Gouvernement du Royaume-Uni de Grande-Bretagne et d’Irlande du Nord.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map72' src="fig72.html" width='100%'  height='500px'/>

            </ContainerChart>

{/* Interactive Map  */}
            <ContainerChart
                title="Figure 73. Évolution de la dégradation des terres à l’échelle mondiale (2015-2019)"
                legend={[
                    {title: 'Cible déjà atteinte', color: '#00a700'},
                    {title: 'En bonne voie', color: '#2acb2a'},
		    {title: 'En progrès, mais trop lent', color: '#ffff05'},
		    {title: 'Aucune amélioration', color: '#ffa500'},
		    {title: 'Détérioration', color: '#ff0000'},
		    {title: 'Données insuffisantes', color: '#808080'},
                ]}
                source={<span><b>Source:</b> FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a> (modifié pour s’aligner sur la Section de l’information géospatiale des Nations Unies, 2023).<br/></span>}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l’Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre le Soudan et le Soudan du Sud n’a pas encore été défini.<br/>Le statut définitif de la zone d’Abyei n’est pas encore déterminé. La souveraineté sur les îles Falkland (Malvinas) fait l’objet d’un différend entre le Gouvernement de l’Argentine et le Gouvernement du Royaume-Uni de Grande-Bretagne et d’Irlande du Nord.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map73' src="fig73.html" width='100%'  height='500px'/>

            </ContainerChart>

<Container>
<div id="section15.4.2">
                    <HeaderSdg
                        title="INDICATEUR 15.4.2 DES ODD"
                        subtitle="a) Indice de couvert végétal montagneux; b) proportion de terres montagneuses dégradées"
                        badges={[
                            {color: '#FFC000', text: 'a) Évaluation de la situation à l’échelle mondiale: en dessous de la médiane des valeurs nationales.'},
                            { color: '#92D050', text: 'Évaluation des tendances à l’échelle mondiale: légère amélioration ou absence d’amélioration.'},
		       {color: '#92D050', text: 'b) Évaluation de la situation à l’échelle mondiale: cible sur le point d’être atteinte.'},
                            { color: '#ff6261', text: 'Évaluation des tendances à l’échelle mondiale: détérioration.'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Cible 15.4',
                            text: 'D’ici à 2030, assurer la préservation des écosystèmes montagneux, notamment de leur biodiversité, afin de mieux tirer parti de leurs bienfaits essentiels pour le développement durable.'
                        }}
                    />
                </div>

<p><b>La part de terres montagneuses dégradées s’élève à 1,6 pour cent de la superficie montagneuse mondiale.</b></p>
<p>Le couvert végétal montagneux est globalement resté stable, à environ 78 pour cent au cours de la période 2000-2018, et connaît une baisse non significative (0,05 pour cent) depuis 2015. La ventilation des zones montagneuses par couverture des sols et région géographique fournit des indications supplémentaires, qui nous permettent de comprendre comment les caractéristiques biophysiques et les utilisations des terres historiques et récentes façonnent leurs paysages (figure 74).</p>
</Container>
<ContainerChart 
                title="Figure 74. Indice de couvert végétal montagneux par type de couverture des sols (2018)"
			 legendCSSClass="half-width-entries"
                legend={[
                    {title: 'Surfaces artificielles', color: '#c00000', customCSSClass: 'half-width'},
                    {title: 'Terres en cultures', color: '#fed966', customCSSClass: 'half-width'},
                    {title: 'Prairies', color: '#c4dda0', customCSSClass: 'half-width'},
                    {title: 'Zones boisées', color: '#548135', customCSSClass: 'half-width'},
                    {title: 'Zones couvertes d’arbustes', color: '#82b99c', customCSSClass: 'half-width'},
                    {title: 'Zones humides', color: '#65b3d6', customCSSClass: 'half-width'},
                    {title: 'Zones à faible végétation', color: '#dcca8f', customCSSClass: 'half-width'},
                    {title: 'Terres stériles', color: '#9a8f72', customCSSClass: 'half-width'},
                    {title: 'Neiges éternelles et glaciers', color: '#d6dce5', customCSSClass: 'half-width'},
                    {title: 'Plans d’eau intérieurs', color: '#5475a8', customCSSClass: 'half-width'},		
                ]}
                note={<span>Note: Ordonnée de droite – répartition des types de couverture des sols dans les différentes régions des ODD en 2018. La taille de chaque barre indique la superficie montagneuse totale pour chaque région des ODD. Ordonnée de gauche – valeurs de l’indice de couvert végétal montagneux en 2018, représenté sous forme de points noirs.<br/><b>Source:</b> FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure74}
                />
                
            </ContainerChart>
<Container>
<p>Les superficies arborées sont le principal type de couverture des sols en montagne à l’échelle mondiale, en particulier en Océanie (90 pour cent de la superficie montagneuse totale), en Europe et en Amérique du Nord (52 pour cent), en Amérique latine et dans les Caraïbes (42 pour cent), en Asie de l’Est et du Sud (38 pour cent) et en Afrique subsaharienne (35 pour cent). Deux exceptions sont à noter: l’Afrique du Nord et l’Asie de l’Ouest, où dominent les terres stériles (40 pour cent) et les terres en culture (25 pour cent), et l’Asie centrale et du Sud, où les types de couverture des sols les plus présents sont les terres stériles (26 pour cent), les prairies (24 pour cent) et les terres en culture (20 pour cent).</p>
<p>Les régions tropicales et subtropicales caractérisées par des chaînes de montagnes de basse ou moyenne altitude, comme l’Océanie, affichent généralement les valeurs de couvert végétal les plus élevées (99 pour cent). Par opposition, les régions caractérisées par des montagnes de haute altitude situées en zone tempérée et boréale, où les conditions environnementales sont moins favorables à la croissance de la végétation, comme l’Asie centrale, l’Amérique du Nord et l’Europe, affichent des valeurs de couvert végétal plus faibles (respectivement 64 pour cent et 76 pour cent). Les zones arides comme l’Afrique du Nord et l’Asie de l’Ouest ont elles aussi tendance à afficher des valeurs de couvert végétal plus basses (46 pour cent).</p>
<p>Les changements préjudiciables de couverture des sols et d’utilisation des terres contribuent fortement à la perte de biodiversité terrestre, y compris dans les écosystèmes montagneux. La part de terres montagneuses dégradées mesure ceci en calculant la superficie montagneuse où des changements de la couverture des sols peuvent être un signe de déclin ou de perte de biodiversité, les fonctions ou services écosystémiques montagneux considérés souhaitables dans le contexte local ou national. À cette fin, les transitions de couverture des sols qui indiquent une baisse ou une perte de biodiversité et de services écosystémiques montagneux sont considérées comme une dégradation des terres montagneuses.</p>
<p className="text-center mb-0"><span><b>Tableau 4. Ceintures bioclimatiques montagneuses et reclassification en vue de la ventilation des données de l’indicateur 15.4.2 des ODD</b></span></p>
                    <table className="annex-table text-center">
                        <thead>
<tr className="text-left">
<th>Ceintures bioclimatiques</th>
<th>Température moyenne de la saison de croissance</th>
<th>Durée de la saison de croissance</th>
<th>Ceintures bioclimatiques adoptées pour l’indicateur 15.4.2 des ODD</th>
</tr>
			</thead>
			<tbody>
<tr>
<td className="text-left"><b>Zone nivale</b></td>
<td>&lt; 3,5 °C</td>
<td>&lt; 10 jours</td>
<td>Zone nivale</td>
</tr>
<tr>
<td className="text-left"><b>Zone alpine supérieure</b></td>
<td>&lt; 3,5 °C</td>
<td>&gt; 10 jours et &lt; 54 jours</td>
<td rowspan="2">Zone alpine</td>
</tr>
<tr>
<td className="text-left"><b>Zone alpine inférieure</b></td>
<td>&lt; 6,4 °C</td>
<td>&lt; 54 jours</td>
</tr>
<tr>
<td colspan="4" className="text-center"><b>LIMITE DE LA VÉGÉTATION</b></td>
</tr>
<tr>
<td className="text-left"><b>Zone montagnarde supérieure</b></td>
<td>&gt; 6,4 °C et &lt; 10 °C</td>
<td>---</td>
<td rowspan="2">Zone montagnarde</td>
</tr>
<tr>
<td className="text-left"><b>Zone montagnarde inférieure</b></td>
<td>&gt; 10 °C et &lt; 15 °C</td>
<td>---</td>
</tr>
<tr>
<td className="text-left"><b>Autres zones de montagne avec gel</b></td>
<td>&gt; 15 °C</td>
<td rowspan="2">---</td>
<td rowspan="2">Autres zones de montagne</td>
</tr>
<tr>
<td className="text-left"><b>Autres zones de montagne sans gel</b></td>
<td>&gt; 15 °C</td>
</tr>
</tbody>
</table>
<p className="note text-center">Note: Les montagnes peuvent être sous-divisées verticalement en sept ceintures bioclimatiques fondées sur les températures moyennes, ce qui permet d’expliquer le changement latitudinal de l’altitude de zones thermiquement similaires dans les zones montagneuses de la planète. Aux fins de l’indicateur 15.4.2, ces sept ceintures bioclimatiques sont regroupées en quatre catégories (zones nivales, alpines, montagnardes et autres zones de montagne).<br/><b>Source:</b> Körner, C., Paulsen, J. et Spehn, E. 2011. «A definition of mountains and their bioclimatic belts for global comparisons of biodiversity data». <i>Alpine Botany</i>, 121: 73–78.</p>
<p>Les données mondiales disponibles indiquent que la superficie où des changements préjudiciables de la couverture des sols ont eu lieu entre 2000 et 2018 représente environ 1,6 pour cent de la superficie montagneuse totale de la planète. Les données ventilées montrent que les ceintures montagneuses les plus touchées par les changements préjudiciables de couverture des sols étaient la zone alpine (1,8 pour cent) et la zone montagnarde (1,7 pour cent), tandis que les zones nivales étaient les moins touchées (0,08 pour cent) (figure 75)<sup onClick={() => handleClickOpen('Ces valeurs doivent être interprétées avec prudence, compte tenu du fait que les changements de la superficie occupée par des neiges et des glaces éternelles ne sont pas encore pris en compte par le jeu de données mondiales sur la couverture des sols utilisé pour cette analyse (Agence spatiale européenne, 2017).')}>9</sup>. La ventilation par région des ODD et par ceinture bioclimatique montre que les superficies comptant la plus forte proportion de terres montagneuses dégradées sont les zones alpines de l’Europe et de l’Amérique du Nord (2,3 pour cent), suivies des zones montagnardes de l’Asie centrale et du Sud (2,2 pour cent) et des ceintures montagneuses moins élevées de l’Asie de l’Est et du Sud (2,1 pour cent). </p>
</Container>
<ContainerChart 
                title="Figure 75. Part de terres montagneuses dégradées dans les différentes régions des ODD, ventilée par ceinture bioclimatique (2000-2018)"
			 legendCSSClass="half-width-entries"
                legend={[
                    {title: 'Zone nivale', color: '#a5a5a5', customCSSClass: 'half-width'},
                    {title: 'Zone alpine', color: '#e6ddcc', customCSSClass: 'half-width'},
                    {title: 'Zone montagnarde', color: '#a9b6a2', customCSSClass: 'half-width'},
                    {title: 'Autres zones de montagne', color: '#6c8b8d', customCSSClass: 'half-width'},
                ]}
                note={<span>Source: FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure75}
                />
                
            </ContainerChart>
<Container>
<p>Enfin, une analyse des changements de types de couverture des sols dans les zones montagneuses de la planète montre que la superficie des surfaces artificielles a plus que doublé (hausse de 106 pour cent) entre 2000 et 2018, en particulier en dessous de la limite de la végétation (zones montagnardes et autres zones de montagne). Les zones humides situées en dessous de la limite de la végétation ont également beaucoup reculé au cours de la même période (figure 76).</p>
</Container>
<ContainerChart 
                title="Figure 76. Évolution de la superficie des différents types de couverture des sols dans les zones montagneuses de la planète entre 2000 et 2018"
			 legendCSSClass="half-width-entries"
                legend={[
                    {title: 'Zone nivale', color: '#a5a5a5', customCSSClass: 'half-width'},
                    {title: 'Zone alpine', color: '#e6ddcc', customCSSClass: 'half-width'},
                    {title: 'Zone montagnarde', color: '#a9b6a2', customCSSClass: 'half-width'},
                    {title: 'Autres zones de montagne', color: '#6c8b8d', customCSSClass: 'half-width'},
                ]}
                note={<span>Source: FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure76}
                />
                
            </ContainerChart>

{/* Interactive Map  */}
            <ContainerChart
                title="Figure 77. État actuel de l’indice de couvert végétal montagneux, par quintile (2018)"
                legend={[
                    {title: 'Cinquième quintile', color: '#00a700'},
                    {title: 'Quatrième quintile', color: '#2acb2a'},
		    {title: 'Troisième quintile', color: '#ffff05'},
		    {title: 'Deuxième quintile', color: '#ffa500'},
		    {title: 'Premier quintile', color: '#ff0000'},
		    {title: 'Données insuffisantes', color: '#808080'},
                ]}
                source={<span><b>Source:</b> FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a> (modifié pour s’aligner sur la Section de l’information géospatiale des Nations Unies, 2023).<br/></span>}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l’Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre le Soudan et le Soudan du Sud n’a pas encore été défini.<br/>Le statut définitif de la zone d’Abyei n’est pas encore déterminé. La souveraineté sur les îles Falkland (Malvinas) fait l’objet d’un différend entre le Gouvernement de l’Argentine et le Gouvernement du Royaume-Uni de Grande-Bretagne et d’Irlande du Nord.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map77' src="fig77.html" width='100%'  height='500px'/>

            </ContainerChart>

{/* Interactive Map  */}
            <ContainerChart
                title="Figure 78. Tendance à la hausse de l’indice de couvert végétal montagneux par région (2015-2018)"
                legend={[
                    {title: 'Amélioration', color: '#00a700'},
                    {title: 'Légère amélioration ou absence d’amélioration', color: '#2acb2a'},
		    {title: 'Légère détérioration', color: '#ffa500'},
		    {title: 'Détérioration', color: '#ff0000'},
		    {title: 'Données insuffisantes', color: '#808080'},
                ]}
                source={<span><b>Source:</b> FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a> (modifié pour s’aligner sur la Section de l’information géospatiale des Nations Unies, 2023).<br/></span>}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l’Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre le Soudan et le Soudan du Sud n’a pas encore été défini.<br/>Le statut définitif de la zone d’Abyei n’est pas encore déterminé. La souveraineté sur les îles Falkland (Malvinas) fait l’objet d’un différend entre le Gouvernement de l’Argentine et le Gouvernement du Royaume-Uni de Grande-Bretagne et d’Irlande du Nord.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map78' src="fig78.html" width='100%'  height='500px'/>

            </ContainerChart>

{/* Interactive Map  */}
            <ContainerChart
                title="Figure 79. État actuel de la dégradation des terres montagneuses (2018)"
                legend={[
                    {title: 'Cible déjà atteinte', color: '#00a700'},
                    {title: 'Cible sur le point d’être atteinte', color: '#2acb2a'},
		    {title: 'Cible en voie d’être atteinte', color: '#ffff05'},
		    {title: 'Cible loin d’être atteinte', color: '#ffa500'},
		    {title: 'Cible très loin d’être atteinte', color: '#ff0000'},
		    {title: 'Données insuffisantes', color: '#808080'},
                ]}
                source={<span><b>Source:</b> FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a> (modifié pour s’aligner sur la Section de l’information géospatiale des Nations Unies, 2023).<br/></span>}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l’Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre le Soudan et le Soudan du Sud n’a pas encore été défini.<br/>Le statut définitif de la zone d’Abyei n’est pas encore déterminé. La souveraineté sur les îles Falkland (Malvinas) fait l’objet d’un différend entre le Gouvernement de l’Argentine et le Gouvernement du Royaume-Uni de Grande-Bretagne et d’Irlande du Nord.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map79' src="fig79.html" width='100%'  height='500px'/>

            </ContainerChart>
{/* Interactive Map  */}
            <ContainerChart
                title="Figure 80. Évolution de la dégradation des terres montagneuses (2015-2018)"
                legend={[
                    {title: 'Cible déjà atteinte', color: '#00a700'},
                    {title: 'En bonne voie', color: '#2acb2a'},
		    {title: 'En progrès, mais trop lent', color: '#ffff05'},
		    {title: 'Aucune amélioration', color: '#ffa500'},
		    {title: 'Détérioration', color: '#ff0000'},
		    {title: 'Données insuffisantes', color: '#808080'},
                ]}
                source={<span><b>Source:</b> FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a> (modifié pour s’aligner sur la Section de l’information géospatiale des Nations Unies, 2023).<br/></span>}
                note={<span>Note: Les pointillés correspondent approximativement à la ligne de contrôle au Jammu-et-Cachemire convenue par l’Inde et le Pakistan. Les parties n’ont pas encore réglé la question du statut définitif du Jammu-et-Cachemire. Le tracé définitif de la frontière entre le Soudan et le Soudan du Sud n’a pas encore été défini.<br/>Le statut définitif de la zone d’Abyei n’est pas encore déterminé. La souveraineté sur les îles Falkland (Malvinas) fait l’objet d’un différend entre le Gouvernement de l’Argentine et le Gouvernement du Royaume-Uni de Grande-Bretagne et d’Irlande du Nord.</span>}>
                <iframe loading='lazy' className='chart-container-image' style={{border: 'none'}} title='map80' src="fig80.html" width='100%'  height='500px'/>

            </ContainerChart>

<Container>
                <div id="section15.6.1">
                    <HeaderSdg
                        title="INDICATEUR 15.6.1 DES ODD"
                        subtitle={["Nombre de pays ayant adopté des cadres législatifs, administratifs et opérationnels destinés à assurer un partage juste et équitable des bénéfices", <sup>10</sup>]}
                        // badges={[
                        //     {color: '#ffbf02', text: 'Status assessment: Not possible due to absence of numerical yardstick in target'},
                        //     {color: '#ff6261', text: 'Trend assessment: Slight or no improvement'},
                        // ]}
                        target={{
                            sdg: "15",
                            title: 'Cible 15.6',
                            text: 'Favoriser le partage juste et équitable des bénéfices découlant de l’utilisation des ressources génétiques et promouvoir un accès approprié à celles-ci, ainsi que cela a été décidé à l’échelle internationale.'
                        }}
                    />
                </div>

                <div className="text-in-box mt-5">
		   <HeaderSdg
                        title="Indicateur 15.6.1 des ODD"
                        subtitle="Pays qui sont parties contractantes au Traité international sur les ressources phytogénétiques pour l’alimentation et l’agriculture"
                         badges={[
                             {color: '#cecece', text: 'Situation actuelle: évaluation non effectuée en raison de l’absence de mesure numérique dans la cible.'},
                             {color: '#00a700', text: 'Évolution: amélioration.'},
                         ]}
                                            />
			      <Subtitle text="Pays qui disposent d’un cadre législatif, administratif et opérationnel ou de mesures législatives, administratives et opérationnelles dont il est fait état dans le Système d’établissement en ligne de rapports sur le respect du Traité international sur les ressources phytogénétiques pour l’alimentation et l’agriculture" />
		   
<div className="sdg-header" id="header2-1-2">
    <div className="text-center">
<div className="badge badge-pill" style={{background: '#cecece'}}>Situation actuelle: évaluation non effectuée en raison de l’absence de mesure numérique dans la cible.</div>
<div className="badge badge-pill" style={{background: '#00a700'}}>Évolution: amélioration.</div>
    </div>
</div>
	  <Subtitle text="Nombre total déclaré d’accords types de transfert de matériel transférant des ressources phytogénétiques pour l’alimentation et l’agriculture au pays" />
		   
<div className="sdg-header" id="header2-1-2">
    <div className="text-center">
<div className="badge badge-pill" style={{background: '#cecece'}}>Situation actuelle: évaluation non effectuée en raison de l’absence de mesure numérique dans la cible.</div>
<div className="badge badge-pill" style={{background: '#00a700'}}>Évolution: amélioration.</div>
    </div>
</div>
</div>
<p className="mt-5"><b>Le nouvel accord sur la biodiversité attire de nouveau l’attention sur le partage juste et équitable des bénéfices découlant de l’utilisation des ressources génétiques.</b></p>
<p>Depuis l’entrée en vigueur du Protocole de Nagoya sur l’accès aux ressources génétiques et le partage juste et équitable des avantages découlant de leur utilisation relatif à la Convention sur la diversité biologique en 2014, le nombre de Parties l’ayant ratifié est passé à 138, dont 137 pays et l’Union européenne, ce qui représente 70 pour cent des Parties à la Convention sur la diversité biologique.</p>
<p>Toutefois, alors que le Protocole de Nagoya se rapproche d’une ratification d’ampleur mondiale, de nombreux pays doivent encore établir les mesures législatives, administratives ou politiques garantissant le partage juste et équitable des avantages découlant de l’utilisation des ressources génétiques et les savoirs traditionnels associés. En 2022, aucun pays supplémentaire n’a publié de mesures dans le Centre d’échange d’informations sur l’accès et le partage des avantages, maintenant le nombre de 68 de l’année précédente. Vingt-cinq pays ont émis 4 440 certificats de conformité reconnus à l’international (soit une hausse de 1 000) prouvant qu’un consentement préalable donné en connaissance de cause avait été accordé et que des conditions mutuellement convenues avaient été établies pour l’accès en 2022.</p>
<p>Au 1<sup>er</sup> janvier 2023, le nombre de parties contractantes au Traité international sur les ressources phytogénétiques pour l’alimentation et l’agriculture (Traité international sur les ressources phytogénétiques) a atteint les 150, dont l’Union européenne, avec deux pays supplémentaires rejoignant les rangs des signataires en 2022. Fin 2022, 88 pays avaient soumis leur rapport national fournissant des informations sur le degré de mise en œuvre des dispositions du traité, y compris sur l’accès et le partage des avantages; neuf pays ont soumis leur rapport en 2022. Le nombre d’accords types de transfert de matériel a également augmenté, passant de 55 566 en 2015 à 91 352 en 2022, ce qui indique qu’un plus grand nombre d’utilisateurs bénéficient d’un accès aux ressources phytogénétiques à des fins de recherche, de sélection et de formation.</p>
<p>Les retards signalés dans les processus législatifs et dans la mise en œuvre des activités de renforcement des capacités dus à la pandémie de covid-19 ont probablement retardé les avancées vers la réalisation de la cible pour certains pays. D’un autre côté, la numérisation des supports de formation et de renforcement des capacités constitue une évolution positive en matière de partage des connaissances.</p>
<p>Le Fonds de partage des avantages, créé par l’Organe directeur du Traité international sur les ressources phytogénétiques, appuie les projets qui exploitent des ressources phytogénétiques pour trouver des solutions à des défis complexes liés à l’insécurité alimentaire et nutritionnelle, à la perte de biodiversité et aux changements climatiques. Son cinquième cycle a été lancé en mai 2022. Le Fonds de partage des avantages est le mécanisme opérationnel permettant de partager les avantages tirés du Système multilatéral du Traité international sur les ressources phytogénétiques et il est financé par les recettes provenant des utilisateurs du Système multilatéral ainsi que par des contributions volontaires.</p>
<p>L’adoption de l’Accord de Kunming-Montréal sur la biodiversité en décembre 2022 à Montréal, de même que la décision par la Conférence des parties à la Convention sur la diversité biologique relative au partage juste et équitable des avantages tirés de l’utilisation d’informations numériques sur les séquences des ressources génétiques, attirent de nouveau l’attention sur la mise en œuvre des cadres relatifs à l’accès et au partage des avantages. Dans le contexte de ce Cadre, de nouveaux indicateurs d’accès et de partage des avantages doivent être développés par un Groupe de spécialistes techniques pour l’Objectif C et la Cible 13. Il s’agit là d’une occasion importante d’améliorer encore la collecte et l’analyse des données sur le partage des avantages tirés des ressources génétiques, d’accélérer les efforts mondiaux visant à conserver et utiliser durablement les ressources génétiques, ainsi que d’améliorer la mise en œuvre, dans un esprit de soutien mutuel, des instruments relatifs à l’accès et au partage des avantages.</p>
</Container>
<ContainerChart 
                title="Figure 81. Nombre d’accords types de transfert de matériel relatifs aux ressources phytogénétiques pour l’alimentation et l’agriculture dans le monde (2012-2022)"
			 legendCSSClass="half-width-entries"
                legend={[
                    {title: 'Australie et Nouvelle-Zélande', color: '#5b9bd6', customCSSClass: 'half-width'},
                    {title: 'Asie de l’Est et Asie du Sud-Est', color: '#ed7e31', customCSSClass: 'half-width'},
                    {title: 'Afrique du Nord', color: '#a6a5a4', customCSSClass: 'half-width'},
                    {title: 'Afrique subsaharienne', color: '#ffbf00', customCSSClass: 'half-width'},
                    {title: 'Europe et Amérique du Nord', color: '#4372c4', customCSSClass: 'half-width'},
                    {title: 'Asie centrale et Asie du Sud', color: '#71ad49', customCSSClass: 'half-width'},
                    {title: 'Amérique latine et Caraïbes', color: '#265e91', customCSSClass: 'half-width'},
                    {title: 'Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)', color: '#9e480e', customCSSClass: 'half-width'},
                    {title: 'Asie de l’Ouest', color: '#636363', customCSSClass: 'half-width'},
                    {title: 'Monde', color: '#9b7200', customCSSClass: 'half-width'},
                ]}
                note={<span><b>Source:</b> FAO. 2023. Données. Dans: <i>Portail de données sur les indicateurs des ODD.</i> Rome. [Consulté le 8 juin 2023]. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">https://www.fao.org/sustainable-development-goals-data-portal/data/fr</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure81}
                />
                
            </ContainerChart>

<Container>
<b>Références:</b>
<p><b>ESA (Agence spatiale européenne).</b> 2017. <i>Land Cover CCI Product. User guide version 2.0</i>. Rome. <a href="https://maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf">https://maps.elie.ucl.ac.be/CCI/viewer/download/ESACCI-LC-Ph2-PUGv2_2.0.pdf</a></p>
<p><b>Körner, C., Paulsen, J. et Spehn, E.</b> 2011. «A definition of mountains and their bioclimatic belts for global comparisons of biodiversity data». <i>Alpine Botany</i>, 121: 73–78.</p>
                    <br /><br />
            <div className="footnotes">
            <p id="footnote8"><sup>8</sup> L’indicateur 15.3.1 des ODD relève de la responsabilité de la Convention des Nations Unies sur la lutte contre la désertification (CLD). La FAO est un organisme participant.</p>
	    <p id="footnote9"><sup>9</sup> Ces valeurs doivent être interprétées avec prudence, compte tenu du fait que les changements de la superficie occupée par des neiges et des glaces éternelles ne sont pas encore pris en compte par le jeu de données mondiales sur la couverture des sols utilisé pour cette analyse (Agence spatiale européenne, 2017).</p>
	    <p id="footnote10"><sup>10</sup> L’indicateur 15.6.1 des ODD relève de la responsabilité du Secrétariat de la Convention sur la diversité biologique (CDB). La FAO est un organisme participant.</p>
	    <br/><br/>
    	    <br/><br/>
	    </div>
            </Container>

        </React.Fragment>
    )
}


export default Sdg15;
